import React, { FunctionComponent, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { get } from 'lodash';
import { ISelectProps } from './types';

import Select from 'react-select';
import { buildStyleForSelectInput } from '../../../../../utils/form/style.util';

export const SelectInput: FunctionComponent<ISelectProps> = ({
  id,
  name,
  defaultOptions,
  validation,
  disabled,
  placeholder,
  rightIcon,
  leftIcon,
  label,
  options,
  isSingle,
  className,
  clearAllActionAvailable = true,
  onInputChange,
  onGetOptionLabel,
}) => {
  const { control, errors, setError } = useFormContext();

  useEffect(() => {
    if (validation && !errors[name] && control.getValues()[name] && control.getValues()[name].length < 1) {
      if (name === 'status') {
        setError(name, { type: 'minLength', message: 'You need to select a status to save' });
      } else {
        setError(name, { type: 'minLength', message: 'You need to add at least one entity' });
      }
    }
  }, [control, errors, name, setError, validation]);

  const handleChange = (e: any, controllerProps: any) => {
    if (onInputChange) {
      onInputChange(controllerProps.name);
    }
    controllerProps.onChange(e);
  };

  const CustomClearIndicator = () => {
    return null;
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultOptions || ''}
      rules={validation}
      disabled={disabled}
      render={(controllerProps) => (
        <>
          {!!get(errors, name, false) && (
            <label htmlFor={name} style={{ color: 'red' }}>
              {`${label ? label + ' - ' : ''} ${get(errors, `${name}.message`)}`}
            </label>
          )}
          {!get(errors, name, false) && <label htmlFor={name}>{label}</label>}
          {leftIcon}
          {rightIcon}
          <Select
            defaultValue={defaultOptions || ''}
            id={id}
            className={`custom-select-new ${className}`}
            name={controllerProps.name}
            disabled={disabled}
            onChange={(e) => handleChange(e, controllerProps)}
            options={options}
            value={controllerProps.value}
            placeholder={placeholder}
            isMulti={isSingle ? undefined : true}
            closeMenuOnSelect={isSingle}
            styles={buildStyleForSelectInput(isSingle ? 0 : controllerProps.value?.length ?? 0)}
            getOptionLabel={onGetOptionLabel}
            components={clearAllActionAvailable ? undefined : { ClearIndicator: CustomClearIndicator }}
          />
        </>
      )}
    />
  );
};
